import { TableCell, withStyles } from "@material-ui/core";

const StyledTableCell = withStyles((theme) => ({
  head: {
    // backgroundColor: theme.palette.primary.main,
    // backgroundColor: theme.palette.grey[200],
    backgroundColor: `hsl(from ${theme.palette.primary.dark} h s calc(l + 76))`,
    color: theme.palette.text.primary,
    textAlign: "center",
    lineHeight: 1,
    // minWidth: 200,
    // padding: "1rem 0",
  },
  body: {
    // fontSize: 14,
    textAlign: "center",
    // minWidth: 200,
    // padding: '4px 0',
  },
}))(TableCell);

export default StyledTableCell;
